import React from 'react'

export const Button = ({text, color="torq-200", textColor="white"}) => {
    return(
        <button className={`font-display font-medium uppercase rounded-md outline-none bg-${color} py-3 px-8 text-${textColor}`}>{text}</button>
    )
}